import block from "bem-cn";
import { Link } from "react-router-dom";
import { routes, routesDescription } from "../../routes";
import "./Routes.scss";

const b = block("Routes");

const Routes = () => {
  const content = (routes: any, desc: any) => (
    <>
      <h2 className={b("sub-title")}>Функциональные маршруты</h2>
      <ul className={b("routes")}>
        {Object.keys(routes)
          .filter((route) => route !== "test")
          .map((route, index) => {
            const link = routes[route].toString();
            return (
              <li className={b("route")}>
                <Link className={b("link")} to={link}>
                  {index + 1 + ". "}
                  {link}
                </Link>
                <span className={b("desc")}>
                  &ensp;{"–"}&ensp;{desc[route].toString()}
                </span>
              </li>
            );
          })}
      </ul>
    </>
  );

  return (
    <div className={b()}>
      <h1 className={b("main-title")}>
        Все маршруты представленные в этом проекте
      </h1>
      {content(routes, routesDescription)}
      {content(routes.test, routesDescription.test)}
    </div>
  );
};

export default Routes;
